import { useEffect, useRef } from 'preact/hooks';

import SearchItem, { type SearchItemTemplateParams } from 'Components/searchItem/index';
import type { RepeaterFunctionInvoker, TemplateFunction, TemplateResult } from 'Components/types';
import { clearCompared } from 'Core/actions/localStorage';
import { useCollapsible } from 'Core/hooks/index';
import { comparedItemsSelector } from 'Core/selectors/localStorage';
import { useDispatch, useSelector } from 'Core/store';
import { cloneSafe } from 'Utils/components';
import { simpleHandler } from 'Utils/roleHandler';

const openHeight = 540;

interface Props {
  template: TemplateFunction<ComparerTemplateParams>;
}

export interface ComparerTemplateParams {
  collapse: boolean;
  items: RepeaterFunctionInvoker<SearchItemTemplateParams>;
}

export default function Comparer({ template }: Props): TemplateResult {
  const dispatch = useDispatch();

  const rootRef = useRef<HTMLElement>(null);
  const { isCollapsed: collapse, toggle: toggleComparer } = useCollapsible(
    rootRef,
    '.cmRepeater_items',
    true,
    { openHeight },
  );

  const itemsData = useSelector(comparedItemsSelector);
  const isEmpty = !itemsData.length;

  useEffect(() => {
    if (isEmpty && !collapse) {
      toggleComparer();
    }
  });

  if (isEmpty) {
    return null;
  }

  const items = itemsData.repeaterComponents(SearchItem);

  const clearComparer = () => dispatch(clearCompared());

  const onClick = simpleHandler({ toggleComparer, clearComparer });

  const component = template.call({ items, collapse });
  return cloneSafe(component, rootRef, { onClick });
}
